import { RestResponse } from '@maverick/http';
import { NativeAuthService } from '../services/nativeAuth/NativeAuth.service';

export class NativeAuthManager {
    private readonly nativeAuthService: NativeAuthService;

    constructor(isOrder: boolean) {
        this.nativeAuthService = new NativeAuthService(isOrder);
    }

    async loginWithEmail(email: string, password: string): Promise<Partial<{ response: RestResponse; error: string }>> {
        const response = await this.nativeAuthService.loginWithEmail({ email: email, password: password });
        if (response.error) {
            return { error: response.errorMessage };
        }

        return { response };
    }

    async loginWithMfa(
        code: string,
        oobCode: string,
        mfaToken: string
    ): Promise<Partial<{ response: RestResponse; error: string }>> {
        const response = await this.nativeAuthService.loginWithMfa({
            code: code,
            oob_code: oobCode,
            mfa_token: mfaToken,
        });
        if (response.error) {
            return { error: response.errorMessage };
        }

        return { response };
    }

    async signup(
        email: string,
        password: string,
        phoneNumber: string,
        firstName: string,
        lastName: string,
        dateOfBirth: string
    ): Promise<Partial<{ response: RestResponse; error: string }>> {
        const response = await this.nativeAuthService.signup({
            email: email,
            password: password,
            phoneNumber: phoneNumber,
            firstName: firstName,
            lastName: lastName,
            dateOfBirth: dateOfBirth,
        });
        if (response.error) {
            return { error: response.errorMessage };
        }

        return { response };
    }

    async mfaListAuthenticators(mfaToken: string): Promise<Partial<{ response: RestResponse; error: string }>> {
        const response = await this.nativeAuthService.mfaListAuthenticators({
            mfa_token: mfaToken,
        });
        if (response.error) {
            return { error: response.errorMessage };
        }

        return { response };
    }

    async mfaSendCode(
        authenticatorId: string,
        mfaToken: string
    ): Promise<Partial<{ response: RestResponse; error: string }>> {
        const response = await this.nativeAuthService.mfaSendCode({
            authenticator_id: authenticatorId,
            mfa_token: mfaToken,
        });
        if (response.error) {
            return { error: response.errorMessage };
        }

        return { response };
    }

    async forgotPassword(email: string): Promise<Partial<{ response: RestResponse; error: string }>> {
        const response = await this.nativeAuthService.forgotPassword({ email: email });
        if (response.error) {
            return { error: response.errorMessage };
        }

        return { response };
    }

    async refreshToken(refreshToken: string): Promise<Partial<{ response: RestResponse; error: string }>> {
        const response = await this.nativeAuthService.refreshToken({ refresh_token: refreshToken });
        if (response.error) {
            return { error: response.errorMessage };
        }

        return { response };
    }
}
